import React from "react"

const contact = props => <div>contact</div>

export default contact



// WEBPACK FOOTER //
// ./src/scenes/Help/pages/contact.js